import { useContext } from 'react'
import { gapiContext } from './context'

export const useGapiIsReady = () => {
  return useContext(gapiContext)
}
